<ng-container *ngIf="!!params">
    <mat-chip-grid #chips class="tt-search-multi-select__mat-chip-grid">
        <mat-chip-row *ngFor="let id of selectedIds" class="tt-search-multi-select__mat-chip-row" (removed)="remove(id)">
            {{ id }}
            <button matChipRemove class="tt-search-multi-select__remove" [attr.aria-label]="'remove ' + id">
                <span class="far fa-times"></span>
            </button>
        </mat-chip-row>
        <mat-chip-row *ngFor="let chip of chipsList" class="tt-search-multi-select__mat-chip-row" (removed)="remove(chip)">
            {{ chip[dataName] }}
            <button matChipRemove class="tt-search-multi-select__remove" [attr.aria-label]="'remove ' + chip[dataId]">
                <span class="far fa-times"></span>
            </button>
        </mat-chip-row>
    </mat-chip-grid>
    <input
        class="tt-lookup-multi__input"
        #inputRef
        #chipInput="matChipInput"
        [formControl]="searchControl"
        [matChipInputFor]="chips"
        [matAutocomplete]="auto"
        (matChipInputTokenEnd)="add($event)"
        (focusout)="onBlur(auto, $event)"
    />
    <!-- <span class="tt-search-multi-select__autocomplete-origin" matAutocompleteOrigin #origin="matAutocompleteOrigin"></span> -->
    <!-- [matAutocompleteConnectedTo]="origin" -->

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" hideSingleSelectionIndicator autoActiveFirstOption multiple class="ag-custom-component-popup">
        <mat-option *ngFor="let item of data | async; trackBy: trackItem" [id]="id + item[params!.key]" class="tt-listbox__item ag-custom-component-popup" [value]="item">
            <span>{{ item[params.keyname] }}</span>
            <!-- <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
        <span>
                        <span *ngIf="!!item[this.ttDataIcon]" class="fad fa-fw" [ngClass]="'' + item[this.ttDataIcon]"></span>
                        {{ item[ttDataName] }}
                    </span>
                    <span *ngIf="selectedIds.includes('' + item[this.ttDataId])" class="far fa-check"></span> -->
        </mat-option>
    </mat-autocomplete>
</ng-container>
